import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  OPTIMIZATION_HISTORY_FEATURE_KEY,
  OptimizationHistoryState
} from './optimization-history.state';

export const selectOptimizationHistoryState =
  createFeatureSelector<OptimizationHistoryState>(OPTIMIZATION_HISTORY_FEATURE_KEY);

export const selectOptimizationHistoryItems = createSelector(
  selectOptimizationHistoryState,
  (s) => s.items
);
export const selectOptimizationHistoryTotal = createSelector(
  selectOptimizationHistoryState,
  (s) => s.total
);
export const selectOptimizationHistoryQuery = createSelector(
  selectOptimizationHistoryState,
  (s) => s.query
);
export const selectOptimizationHistoryLoading = createSelector(
  selectOptimizationHistoryState,
  (s) => s.loading
);
export const selectPageOpen = createSelector(
  selectOptimizationHistoryState,
  (s) => s.pageOpen
);
export const selectHasUnseenJobs = createSelector(
  selectOptimizationHistoryState,
  (s) => s.hasUnseenJobs
);
